var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconeLocalisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M6 1C3.79086 1 2 3.00129 2 5.25C2 7.4811 3.27666 9.9062 5.26855 10.8372C5.73285 11.0542 6.26715 11.0542 6.73145 10.8372C8.72335 9.9062 10 7.4811 10 5.25C10 3.00129 8.20915 1 6 1Z",
    fill: "#BDBDBD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 6.25C6.69035 6.25 7.25 5.69035 7.25 5C7.25 4.30964 6.69035 3.75 6 3.75C5.30965 3.75 4.75 4.30964 4.75 5C4.75 5.69035 5.30965 6.25 6 6.25Z",
    fill: "#BDBDBD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeLocalisation);
export default __webpack_public_path__ + "static/media/IconeLocalisation.8c511ccf50d46814b5022c0c6f8e48d9.svg";
export { ForwardRef as ReactComponent };